import { render, staticRenderFns } from "./teacherElectronic.vue?vue&type=template&id=0413792a&scoped=true&"
import script from "./teacherElectronic.vue?vue&type=script&lang=js&"
export * from "./teacherElectronic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0413792a",
  null
  
)

export default component.exports